export const SUBMIT_CHARACTERISTICS = 'SUBMIT_CHARACTERISTICS';
export const SUBMIT_GOAL_RATIO = 'SUBMIT_GOAL_RATIO';
export const SUBMIT_NUTRITION_RATIO = 'SUBMIT_NUTRITION_RATIO';
export const CHARACTERISTICS_INPUT_CHANGE = 'CHARACTERISTICS_INPUT_CHANGE';

export const ADD_ROW_TO_MENU = 'ADD_ROW_TO_MENU';
export const MENU_ROW_INPUT_CHANGE = 'MENU_ROW_INPUT_CHANGE';
export const CALCULATE_MENU_NUTRITION = 'CALCULATE_MENU_NUTRITION';
export const DELETE_MENU_ROW = 'DELETE_MENU_ROW';

export const SUBMIT_PRODUCT = 'SUBMIT_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';

export const ActionNames = Object.freeze({
    SUBMIT_CHARACTERISTICS,
    SUBMIT_GOAL_RATIO,
    SUBMIT_NUTRITION_RATIO,
    CHARACTERISTICS_INPUT_CHANGE,

    ADD_ROW_TO_MENU,
    MENU_ROW_INPUT_CHANGE,
    CALCULATE_MENU_NUTRITION,
    DELETE_MENU_ROW,

    SUBMIT_PRODUCT,
    DELETE_PRODUCT,
});
